/* global axios */
import ApiClient from './ApiClient';

class TaskAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(taskData) {
    const formData = this.prepareFormData(taskData);
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(id, taskData) {
    const formData = this.prepareFormData(taskData);
    return axios.patch(`${this.url}/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  updatePositions(tasks) {
    return axios.post(`${this.url}/update_positions`, { tasks });
  }

  // eslint-disable-next-line class-methods-use-this
  prepareFormData(taskData) {
    const formData = new FormData();

    // Ajouter les champs simples
    Object.keys(taskData).forEach(key => {
      if (key === 'files') {
        // Gérer les fichiers séparément
        if (taskData.files && Array.isArray(taskData.files)) {
          taskData.files.forEach(file => {
            if (file instanceof File) {
              // Nouveau fichier à uploader
              formData.append(`files[][file]`, file);
              formData.append(`files[][name]`, file.name);
            } else if (file.id) {
              // Fichier existant (déjà dans Drive)
              formData.append(`files[][id]`, file.id);
            }
          });
        }
      } else if (key === 'tags') {
        // Tags en tant qu'array
        if (taskData.tags && Array.isArray(taskData.tags)) {
          taskData.tags.forEach(tag => {
            formData.append(`task[tags][]`, tag);
          });
        }
      } else if (taskData[key] !== null && taskData[key] !== undefined) {
        formData.append(`task[${key}]`, taskData[key]);
      }
    });

    return formData;
  }
}

export default new TaskAPI();
